import { createSectionItemId } from '@griply/utils';
import React from 'react';
import { Habit } from 'shared/types/habit';
import { ID } from 'shared/types/id';
import { Timestamp } from 'shared/types/timestamp';

import { HabitDetailCard } from '../habit-detail-card';
import * as Styled from './habits-list.style';

export type HabitsListProps = {
  items: Habit[];
  onHabit?: (habit: Habit) => void;
  weekDate: Timestamp;
  isSortable?: boolean;
  // Set by section lists: a habit under two goals renders in both, so each row needs its own sortable id.
  sectionId?: ID;
};

export const HabitsList: React.FC<HabitsListProps> = ({
  items,
  weekDate,
  onHabit,
  isSortable,
  sectionId,
}) => (
  <Styled.List>
    {items.map((habit) => (
      <Styled.ListItem key={habit.id}>
        <HabitDetailCard
          habit={habit}
          weekDate={weekDate}
          onClick={onHabit}
          isSortable={isSortable}
          sortableId={
            sectionId ? createSectionItemId(sectionId, habit.id) : undefined
          }
        />
      </Styled.ListItem>
    ))}
  </Styled.List>
);
